var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedArtist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/verified-artist") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "0.0003125%",
    cy: "50.0015625%",
    fx: "0.0003125%",
    fy: "50.0015625%",
    r: "100%",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C7DFC",
    offset: "69.6705638%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.6925106,0.293246685 C11.0828396,-0.097472723 11.7160045,-0.0977891472 12.106724,0.292539931 C12.4974434,0.68286901 12.4977598,1.31603391 12.1074307,1.70675332 L4.10745329,9.71473071 C3.71698628,10.1055882 3.08354874,10.1057465 2.69288644,9.71508418 L0.292893219,7.31509095 C-0.0976310729,6.92456666 -0.0976310729,6.29140168 0.292893219,5.90087739 C0.683417511,5.5103531 1.31658249,5.5103531 1.70710678,5.90087739 L3.4,7.593 L10.6925106,0.293246685 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/verified-artist",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5529418,33.1562703 C14.6072694,33.8386534 13.2874695,33.6252153 12.6050864,32.6795428 C12.5522953,32.606383 12.5042473,32.529915 12.4612377,32.450609 C11.7778141,31.1904342 10.364112,30.5096312 8.95276012,30.7610152 C7.80466373,30.9655093 6.7081725,30.2005685 6.50367842,29.0524721 C6.48785818,28.9636522 6.47774663,28.8739096 6.47340592,28.7837962 C6.40443189,27.3518916 5.42611969,26.1251269 4.04546409,25.7392535 C2.92233833,25.4253559 2.26632925,24.2604184 2.5802268,23.1372926 C2.60451079,23.0504044 2.63433843,22.965162 2.66952631,22.8820892 C3.22866299,21.5620611 2.87950741,20.0323105 1.80300391,19.0856065 C0.927297604,18.3154886 0.841701312,16.9812844 1.61181924,16.1055781 C1.67139771,16.0378311 1.73525682,15.973972 1.80300391,15.9143935 C2.87950741,14.9676895 3.22866299,13.4379389 2.66952631,12.1179108 C2.21468384,11.0441038 2.71645373,9.80488851 3.79026073,9.35004604 C3.87333345,9.31485816 3.95857594,9.28503052 4.04546409,9.26074653 C5.42611969,8.87487308 6.40443189,7.64810838 6.47340592,6.21620377 C6.52951441,5.05138834 7.5192688,4.15260378 8.68408423,4.20871227 C8.77419761,4.21305298 8.86394017,4.22316454 8.95276012,4.23898478 C10.364112,4.49036883 11.7778141,3.80956578 12.4612377,2.54939102 C13.0171842,1.52427314 14.2988901,1.14393457 15.324008,1.69988105 C15.403314,1.74289062 15.479782,1.79093866 15.5529418,1.84372973 C16.7154545,2.68258158 18.2845455,2.68258158 19.4470582,1.84372973 C20.3927306,1.16134657 21.7125305,1.37478471 22.3949136,2.32045715 C22.4477047,2.39361702 22.4957527,2.47008503 22.5387623,2.54939102 C23.2221859,3.80956578 24.635888,4.49036883 26.0472399,4.23898478 C27.1953363,4.03449069 28.2918275,4.7994315 28.4963216,5.94752789 C28.5121418,6.03634783 28.5222534,6.12609039 28.5265941,6.21620377 C28.5955681,7.64810838 29.5738803,8.87487308 30.9545359,9.26074653 C32.0776617,9.57464408 32.7336708,10.7395816 32.4197732,11.8627074 C32.3954892,11.9495956 32.3656616,12.034838 32.3304737,12.1179108 C31.771337,13.4379389 32.1204926,14.9676895 33.1969961,15.9143935 C34.0727024,16.6845114 34.1582987,18.0187156 33.3881808,18.8944219 C33.3286023,18.9621689 33.2647432,19.026028 33.1969961,19.0856065 C32.1204926,20.0323105 31.771337,21.5620611 32.3304737,22.8820892 C32.7853162,23.9558962 32.2835463,25.1951115 31.2097393,25.649954 C31.1266666,25.6851418 31.0414241,25.7149695 30.9545359,25.7392535 C29.5738803,26.1251269 28.5955681,27.3518916 28.5265941,28.7837962 C28.4704856,29.9486117 27.4807312,30.8473962 26.3159158,30.7912877 C26.2258024,30.786947 26.1360598,30.7768355 26.0472399,30.7610152 C24.635888,30.5096312 23.2221859,31.1904342 22.5387623,32.450609 C21.9828158,33.4757269 20.7011099,33.8560654 19.675992,33.300119 C19.596686,33.2571094 19.520218,33.2090613 19.4470582,33.1562703 C18.2845455,32.3174184 16.7154545,32.3174184 15.5529418,33.1562703 Z",
    id: "Star",
    fill: "url(#radialGradient-1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/tick-small-white",
    transform: "translate(11.100029, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/white",
    mask: "url(#mask-3)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.600029, -7.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedArtist);
export default __webpack_public_path__ + "static/media/verified-artist.b2da1c61151a4f5127c988befe24f846.svg";
export { ForwardRef as ReactComponent };